<template>
    <div class="base-input-number">
        <el-input-number
            v-model="model"
            :min="minValue"
            :max="maxValue"
            :step="step"
            :precision="precision"
            :data-test="dataTestName"
            :data-testid="dataTestName || 'input-number'"
            :disabled="disabled"
            :name="name"
            :placeholder="placeholder"
            :controls="controls"
            class="base-input-number__input"
            @change="onChange"
        />
    </div>
</template>

<script setup lang="ts">
import { InputNumber as ElInputNumber } from 'element-ui'
import { computed } from 'vue'

// const listeners = useListeners()

interface IProps {
    value?: number | string
    minValue?: number
    maxValue?: number
    step?: number
    precision?: number
    controls?: boolean
    disabled?: boolean
    name?: string
    label?: string
    dataTestName?: string
    placeholder?: string
}

const props = withDefaults(
    defineProps<IProps>(),
    {
        value: undefined,
        minValue: 0,
        maxValue: Infinity,
        step: 1,
        precision: undefined,
        controls: true,
        name: undefined,
        label: undefined,
        placeholder: undefined,
        dataTestName: 'baseInputNumber'
    }
)
const emit = defineEmits([ 'input', 'update:value', 'change' ])

const model = computed({
    get: () => props.value !== undefined ? +props.value : props.value,
    set: (val) => {
        const value = val?.toString()
        emit('update:value', value)
        emit('input', value)
    }
})

function onChange (val: number) {
    emit('change', val)
}
</script>

<style lang="scss">
.base-input-number {
    @apply relative px-11;
    .el-input-number__decrease {
        @apply bg-transparent rounded h-8 border border-field-borders flex items-center justify-center top-0;
        left: -44px;
    }

    .el-input-number__increase {
        @apply bg-transparent rounded h-8 border border-field-borders flex items-center justify-center top-0;
        right: -44px;
    }

    .el-input-number {
        @apply leading-5;
        width: auto;
    }

    /* TODO: temporary fix, overwrite App.vue row 412 */
    .el-input-number__increase, .el-input-number__decrease {
        background-color: transparent !important;
    }

    .el-input-number .el-input__inner {
        @apply px-3 h-8 max-w-16 border-field-borders;
    }

    .el-input-number__decrease:not(.is-disabled):hover ~ .el-input:not(.is-disabled) .el-input__inner,
    .el-input-number__increase:not(.is-disabled):hover ~ .el-input:not(.is-disabled) .el-input__inner,
    .el-input .el-input__inner:focus {
        @apply border-primary-actions;
    }

    .el-input-number.is-disabled {
        @apply opacity-50;
        .el-input .el-input__inner {
            @apply border-field-borders;
        }
    }

    .el-input-number.is-disabled .el-input-number__decrease:hover ~ .el-input .el-input__inner,
    .el-input-number.is-disabled .el-input-number__increase:hover ~ .el-input .el-input__inner {
        @apply border-field-borders;
    }
}
</style>
